import { put, takeEvery } from 'redux-saga/effects';
import { FETCH_ERROR, resolveRedirectTo } from 'react-admin';
import { push } from 'connected-react-router';

function* inspectError({ error }) {
	if (error && error.body && error.body._approvableAdminActionId) {
		yield put(push(resolveRedirectTo('show', '/approvableAdminActions', error.body._approvableAdminActionId)));
	}
}

function* approvableAdminActionSaga() {
	yield takeEvery(FETCH_ERROR, inspectError);
}

export default approvableAdminActionSaga;
